import AllLotteryActions from './AllLotteryActions';

export default AllLotteryActions;
